"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RollupGeneralHandler", {
    enumerable: true,
    get: function() {
        return RollupGeneralHandler;
    }
});
const _computed = require("../computed");
const _genRollupSelectv2 = /*#__PURE__*/ _interop_require_default(require("~/db/genRollupSelectv2"));
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let RollupGeneralHandler = class RollupGeneralHandler extends _computed.ComputedFieldHandler {
    async filter(knex, filter, column, options) {
        const { baseModel: baseModelSqlv2, depth: aliasCount, conditionParser: parseConditionV2, alias } = options;
        const context = baseModelSqlv2.context;
        const builder = (await (0, _genRollupSelectv2.default)({
            baseModelSqlv2,
            knex,
            alias,
            columnOptions: await column.getColOptions(context)
        })).builder;
        return parseConditionV2(baseModelSqlv2, new _models.Filter(_extends({}, filter, {
            value: knex.raw('?', [
                // convert value to number for rollup since rollup is always number
                isNaN(+filter.value) ? filter.value : +filter.value
            ])
        })), aliasCount, alias, builder);
    }
};
